import React from 'react';

interface CheckCircleIconProps {
  /**
   * Icon color, defaults to currentColor
   */
  fill?: string;
  /**
   * Icon width
   */
  width?: number;
  /**
   * Icon height
   */
  height?: number;
  /**
   * CSS className
   */
  className?: string;
}

const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({
  fill = 'currentColor',
  width = 24,
  height = 24,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.625 10.9357L8.175 9.51071C7.99167 9.32738 7.7625 9.23571 7.4875 9.23571C7.2125 9.23571 6.975 9.33571 6.775 9.53571C6.59167 9.71905 6.5 9.95238 6.5 10.2357C6.5 10.519 6.59167 10.7524 6.775 10.9357L8.925 13.0857C9.125 13.2857 9.35833 13.3857 9.625 13.3857C9.89167 13.3857 10.125 13.2857 10.325 13.0857L14.575 8.83571C14.775 8.63571 14.8708 8.40238 14.8625 8.13571C14.8542 7.86905 14.7583 7.63571 14.575 7.43571C14.375 7.23571 14.1375 7.13155 13.8625 7.12321C13.5875 7.11488 13.35 7.21071 13.15 7.41071L9.625 10.9357ZM6.825 19.9857L5.375 17.5357L2.625 16.9357C2.375 16.8857 2.175 16.7565 2.025 16.5482C1.875 16.3399 1.81667 16.1107 1.85 15.8607L2.125 13.0357L0.25 10.8857C0.0833333 10.7024 0 10.4857 0 10.2357C0 9.98571 0.0833333 9.76905 0.25 9.58571L2.125 7.43571L1.85 4.61071C1.81667 4.36071 1.875 4.13155 2.025 3.92321C2.175 3.71488 2.375 3.58571 2.625 3.53571L5.375 2.93571L6.825 0.485714C6.95833 0.269048 7.14167 0.123214 7.375 0.0482143C7.60833 -0.0267857 7.84167 -0.0142857 8.075 0.0857143L10.675 1.18571L13.275 0.0857143C13.5083 -0.0142857 13.7417 -0.0267857 13.975 0.0482143C14.2083 0.123214 14.3917 0.269048 14.525 0.485714L15.975 2.93571L18.725 3.53571C18.975 3.58571 19.175 3.71488 19.325 3.92321C19.475 4.13155 19.5333 4.36071 19.5 4.61071L19.225 7.43571L21.1 9.58571C21.2667 9.76905 21.35 9.98571 21.35 10.2357C21.35 10.4857 21.2667 10.7024 21.1 10.8857L19.225 13.0357L19.5 15.8607C19.5333 16.1107 19.475 16.3399 19.325 16.5482C19.175 16.7565 18.975 16.8857 18.725 16.9357L15.975 17.5357L14.525 19.9857C14.3917 20.2024 14.2083 20.3482 13.975 20.4232C13.7417 20.4982 13.5083 20.4857 13.275 20.3857L10.675 19.2857L8.075 20.3857C7.84167 20.4857 7.60833 20.4982 7.375 20.4232C7.14167 20.3482 6.95833 20.2024 6.825 19.9857Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckCircleIcon;
